import React from 'react';
import { AlertTriangle } from 'lucide-react';
export function ProblemSection() {
  return <section className="py-16 px-4 bg-gray-900 text-white" data-id="element-202">
      <div className="max-w-3xl mx-auto" data-id="element-203">
        <div className="flex justify-center mb-6" data-id="element-204">
          <AlertTriangle className="w-16 h-16 text-yellow-500" data-id="element-205" />
        </div>

        <h2 className="md:text-4xl font-black text-center mb-10 text-yellow-500 uppercase tracking-wide text-[26px]" data-id="element-206">
          EL PROBLEMA QUE NADIE DICE EN VOZ ALTA
        </h2>
        <p className="text-xl text-center mb-10 text-gray-300" data-id="element-207">
          Si querés arrancar o crecer en el detailing, esto seguramente te
          resulta familiar:
        </p>

        <div className="space-y-4 max-w-2xl mx-auto text-lg md:text-xl font-medium bg-gray-800 p-8 rounded-2xl border border-gray-700 shadow-2xl" data-id="element-208">
          <p className="flex items-start gap-3" data-id="element-209">
            <span className="text-red-500 mt-1" data-id="element-210">✖</span>
            <span data-id="element-211">Trabajas horas pero no sabés si cobrás bien</span>
          </p>
          <p className="flex items-start gap-3" data-id="element-212">
            <span className="text-red-500 mt-1" data-id="element-213">✖</span>
            <span data-id="element-214">Tenés ganas pero no tenés un sistema</span>
          </p>
          <p className="flex items-start gap-3" data-id="element-215">
            <span className="text-red-500 mt-1" data-id="element-216">✖</span>
            <span data-id="element-217">Mirás videos de YouTube y cada uno dice algo diferente</span>
          </p>
          <p className="flex items-start gap-3" data-id="element-218">
            <span className="text-red-500 mt-1" data-id="element-219">✖</span>
            <span data-id="element-220">
              Comprás productos sin saber si son los correctos para cada caso
            </span>
          </p>
          <p className="flex items-start gap-3" data-id="element-221">
            <span className="text-red-500 mt-1" data-id="element-222">✖</span>
            <span data-id="element-223">Terminás improvisando más de lo que te gustaría</span>
          </p>
          <p className="flex items-start gap-3" data-id="element-224">
            <span className="text-red-500 mt-1" data-id="element-225">✖</span>
            <span data-id="element-226">
              Arruinaste o casi arruinaste alguna pintura por no saber el orden
              correcto
            </span>
          </p>
        </div>

        <div className="mt-12 text-center" data-id="element-227">
          <p className="text-xl text-gray-400 mb-4" data-id="element-228">
            Lo peor es esa sensación constante de:
          </p>
          <blockquote className="text-2xl md:text-3xl font-bold italic text-white border-l-4 border-yellow-500 pl-6 py-2 max-w-2xl mx-auto text-left" data-id="element-229">
            "Podría ganar mucho más… 
            <br data-id="element-230" /> si supiera exactamente qué hacer."
          </blockquote>
        </div>
      </div>
    </section>;
}